import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// @material-ui/core components
import AddCircle from '@material-ui/icons/Add';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getSuperCategory as getCategoryList } from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

var update = false;
function CategoryTableList(props) {
  const classes = useStyles();
  useEffect(() => {
    props.getCategoryList();
  }, []);

  const { className } = props;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);
  const data = [];
  {
    var c = 1;
    props.superCategories &&
      props.superCategories.map((category) => {
        data.push({
          sno: c,
          name: category
        });
        c += 1;
      });
  }

  const handleDelete = (superCategoryId) => {
    props.deleteSuperCategories(superCategoryId);
    if (update === false) {
      update = true;
      setTimeout(() => {
        update = false;
      }, 2500);
    } else {
      update = true;
      update = false;
    }
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>All super-categories</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Added by</th>
            <th>Name</th>
            <th>Icon</th>
            <th>Category</th>
            <th>Add</th>
          </tr>
        </thead>
        <tbody>
          {props.superCategories.length !== 0 ? (
            props.superCategories.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{i + 1}</th>
                <td>A {item.userRoleOfAddedBy}</td>
                <td>{item.name}</td>
                <td>
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={{ height: '70px' }}
                  />
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={'/vendor/all-category/' + item.id}
                  >
                    View All
                  </Link>
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={'/vendor/add-category/' + item.id}
                  >
                    <AddCircle
                      onClick={function (event) {
                        toggle();
                      }}
                    />{' '}
                    Add category
                  </Link>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>
          Do you really want to delete this Super Category??
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a super category</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

const mapStateWithProps = (state) => ({
  superCategories: state.vendor.superCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList())
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(CategoryTableList);
